import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  tasks: [],
  currentTask: null,
  logs: [],
  loading: false,
  error: null,
}

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    setTasks: (state, action) => {
      state.tasks = action.payload
      state.loading = false
      state.error = null
    },
    setCurrentTask: (state, action) => {
      state.currentTask = action.payload
    },
    addTask: (state, action) => {
      state.tasks.unshift(action.payload)
    },
    updateTask: (state, action) => {
      const index = state.tasks.findIndex(t => t.id === action.payload.id)
      if (index !== -1) {
        state.tasks[index] = action.payload
      }
    },
    removeTask: (state, action) => {
      state.tasks = state.tasks.filter(t => t.id !== action.payload)
    },
    setLogs: (state, action) => {
      state.logs = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const {
  setTasks,
  setCurrentTask,
  addTask,
  updateTask,
  removeTask,
  setLogs,
  setLoading,
  setError,
  clearError,
} = taskSlice.actions

export default taskSlice.reducer

// Selectors
export const selectTasks = (state) => state.task.tasks
export const selectCurrentTask = (state) => state.task.currentTask
export const selectTaskLogs = (state) => state.task.logs
export const selectTaskLoading = (state) => state.task.loading
export const selectTaskError = (state) => state.task.error
